export default __webpack_public_path__ + "static/media/green-star.c1a33187.svg";